module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-input auth-input-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-4"
  }), _vm._v(" "), _c('form', {
    class: {
      'mt-2': _vm.onMobile
    },
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form-group _email text-xs-center",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    staticClass: "auth-label-input d-flex"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "email",
    class: {
      input: true,
      'text-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": " ",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('email')) ? _c('p', {
    staticClass: "text-danger text-xs-left mb-0",
    class: {
      'mb-2': _vm.onMobile
    }
  }, [_vm._v("\n        " + _vm._s(_vm.errors.first("email")) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group _password text-xs-center my-1"
  }, [_c('label', {
    staticClass: "auth-label-input d-flex"
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "password",
    attrs: {
      "type": "password",
      "placeholder": " ",
      "autocomplete": "new-password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-4",
    class: {
      'mt-0': _vm.onMobile
    }
  }, [_c('v-btn', {
    staticClass: "auth-button login-btn-text",
    class: _vm.checkUserEmpty ? 'auth-bg-disabled' : 'auth-bg-active',
    attrs: {
      "depressed": "",
      "block": "",
      "round": "",
      "dark": "",
      "type": "submit",
      "loading": _vm.loading
    }
  }, [_vm._v("\n        Login\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password mb-4 mt-5"
  }, [_c('span', {
    staticClass: "forgot-password-text cursor-pointer",
    on: {
      "click": function($event) {
        !_vm.showForgotPassword ? _vm.$route.push('/forgot') : _vm.showForgotPassword()
      }
    }
  }, [_vm._v("\n          Forgot password\n        ")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": "/static/images/nav_logo_primary.png",
      "aspect-ratio": "1",
      "width": "174"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36e8a24d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/loginInput.vue
// module id = 1681
// module chunks = 180